import React from "react";

export const Context = React.createContext({
  isLogin: false,
  setIsLogin: (value: boolean) => {},
});
